
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"12","height":"2","x":"6","y":"11","rx":"1"}})])
          )
        }
      }
    